// extracted by mini-css-extract-plugin
export default {"projects_div":"ProjectList_projects_div__oXUjW","project_div":"ProjectList_project_div__+jYBV","user_input_wrapper":"ProjectList_user_input_wrapper__zsTce"};